import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Copy, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

interface TemplateBlockProps {
  title: string;
  content: string;
  type?: "headline" | "section" | "copy";
}

export const TemplateBlock = ({ title, content, type = "copy" }: TemplateBlockProps) => {
  const { toast } = useToast();

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    toast({
      title: "Copied!",
      description: "Template copied to clipboard.",
    });
  };

  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg flex items-center gap-2">
            <FileText className="h-4 w-4 text-primary" />
            {title}
          </CardTitle>
          <Button variant="ghost" size="sm" onClick={handleCopy} className="gap-2">
            <Copy className="h-4 w-4" />
            Copy
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="bg-muted p-4 rounded-lg font-mono text-sm whitespace-pre-wrap">
          {content}
        </div>
      </CardContent>
    </Card>
  );
};
